import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { aboutStoryImage } from '@/mocks/about';

export default function StorySection() {
  const { t } = useTranslation('about');
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="w-full bg-white py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
            <div
              className={`transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <span className="text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-3 block">
                {t('story.label')}
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 mb-5">
                {t('story.title')}
              </h2>
              <div className="space-y-4 text-sm md:text-base text-ink-400 leading-relaxed">
                <p>{t('story.p1')}</p>
                <p>{t('story.p2')}</p>
                <p>{t('story.p3')}</p>
              </div>
            </div>

            <div
              className={`relative transition-all duration-700 delay-100 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <div className="aspect-[3/2] w-full overflow-hidden rounded-xl">
                <img
                  src={aboutStoryImage}
                  alt="GBCOSPACK team collaborating on cosmetic packaging"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}